import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  needToSchedulePickupTitle: {
    id: 'HdShsJ',
    description: 'Title asking if user needs to schedule a pickup',
    defaultMessage: 'Need to Schedule a Pickup?',
  },
  requiresScheduledPickupMessage: {
    id: 'Hq2AAc',
    description: 'Message explaining that the label provider requires scheduled pickup with fee',
    defaultMessage: '{labelProviderName} requires a scheduled pickup with an associated fee.',
  },
  scheduleNowOrLaterMessage: {
    id: 'zIXzxl',
    description: 'Message about scheduling now or later with link to carrier pickups',
    defaultMessage: 'Schedule now, or manage any time from <link>Carrier Pickups</link>',
  },
  carrierPickupsLinkText: {
    id: 'x3nim2',
    description: 'Link text for carrier pickups page',
    defaultMessage: 'Carrier Pickups',
  },
  doLaterButton: {
    id: 'owMUTf',
    description: 'Button text for doing pickup scheduling later',
    defaultMessage: "I'll do this later",
  },
  schedulePickupButton: {
    id: '1nTpY6',
    description: 'Button text for scheduling pickup now',
    defaultMessage: 'Schedule Pickup',
  },
  learnMoreMessage: {
    id: 'sUsUgR',
    description: 'Message with link to learn more about the label provider',
    defaultMessage: 'Learn more about {labelProviderName}',
  },
  selectDifferentCarrier: {
    id: 'q1u3jz',
    description: 'Button text for selecting for cancelling creating label to select a different carrier',
    defaultMessage: 'Select a Different Carrier',
  },
  createFirstLabel: {
    id: 'twtH8K',
    description: 'Action button message to create the first label with the label provider, conditionally includes printing',
    defaultMessage: '{andPrint, select, true {Create + Print Label} other {Create Label}}',
  },
  bulkcreateAmazonLabelWithPickup: {
    id: '8tSNbZ',
    description: 'Message informing user they are creating Amazon labels that require pickup',
    defaultMessage: 'Not planning to schedule a pickup? No problem, just select another carrier.',
  },
});
